"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInput = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var techsee_base_control_component_1 = require("../_shared/techsee-base-control-component");
var FormControl_1 = __importDefault(require("react-bootstrap/lib/FormControl"));
var form_group_1 = __importDefault(require("../form-group"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
require("./styles.scss");
var FormInput = (function (_super) {
    __extends(FormInput, _super);
    function FormInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormInput.prototype.renderInternal = function () {
        var _a = this.props, uid = _a.uid, className = _a.className, model = _a.model, inputRef = _a.inputRef, componentClass = _a.componentClass, minLength = _a.minLength, maxLength = _a.maxLength;
        this.addCssClass('form-input');
        this.addCssClass(className);
        var restProps = {};
        if (!(0, isUndefined_1.default)(minLength)) {
            restProps.minLength = minLength;
        }
        if (!(0, isUndefined_1.default)(maxLength)) {
            restProps.maxLength = maxLength;
        }
        return (react_1.default.createElement(form_group_1.default, { uid: uid, className: this.renderCssClasses(), isRequired: this.isRequired(), showErrors: this.shouldDisplayError(), label: model.label, labelFor: uid, errors: model.errors, iconName: model.iconName },
            react_1.default.createElement(FormControl_1.default, __assign({ id: uid, componentClass: componentClass, type: this.props.inputType, placeholder: model.placeholder, value: model.value, readOnly: model.readOnly, disabled: model.disabled, onChange: this.handleChangeEvent, onBlur: this.handleBlurEvent, onKeyDown: this.handleKeyDown, inputRef: inputRef }, restProps))));
    };
    FormInput.defaultProps = {
        inputType: 'text',
        componentClass: 'input'
    };
    FormInput = __decorate([
        mobx_react_1.observer
    ], FormInput);
    return FormInput;
}(techsee_base_control_component_1.TechseeBaseControlComponent));
exports.FormInput = FormInput;
exports.default = FormInput;
